module.exports = __webpack_public_path__ + "img/hato-white.839db924.svg";